import React from "react";

const LABEL_IMAGES = {
  ip_suisse: "/labels/ip_suisse.png",
  bio_suisse: "/labels/bio_suisse.png",
  soil_association_organic: "/labels/soil_association_organic.png",
  msc: "/labels/msc.png",
  fairtrade: "/labels/fairtrade.png",
  under_650kcal: "/labels/under_650kcal.png",
};

function normalizeLabelKey(label) {
  return label.trim().toLowerCase().replace(/\s+/g, "_");
}

// Renders a product's comma-separated labelInfo as badge images (or text when
// no image exists). `compact` is the small overlay used on store-front cards.
function ProductLabels({ labelInfo, compact = false }) {
  const className = compact ? "store-card-labels" : "store-detail-labels";
  return (
    <div className={className}>
      {labelInfo.split(",").map((label, idx) => {
        const trimmed = label.trim();
        const src = LABEL_IMAGES[normalizeLabelKey(trimmed)];
        return src ? (
          <img
            key={idx}
            src={src}
            alt={trimmed}
            title={trimmed}
            className="store-label-badge"
          />
        ) : (
          <span key={idx} className="store-label-text">{trimmed}</span>
        );
      })}
    </div>
  );
}

export default ProductLabels;
